<template>
  <div v-if="apunte">
    <h4>Detalles del apunte {{ apunte.id }}</h4>

    <ul>
      <li><b>Importe:</b> {{ apunte.importe }} €</li>
      <li><b>Concepto:</b> {{ apunte.concepto }}</li>
      <li><b>Fecha del apunte:</b> {{ apunte.fecha | fechaTimestamp }}</li>
    </ul>
    <ul>
      <template v-if="false && apunte.tipo == 'cuota_actividad'">
      <li><b>Persona:</b> {{ apunte.detalles.persona }}</li>
      <li><b>Período:</b> {{ apunte.detalles.periodo }}</li>
      <li><b>Actividad:</b> {{ apunte.detalles.actividad }}</li>
      <li><b>Grupo:</b> {{ apunte.detalles.grupo }}</li>
      <li v-if="apunte.detalles.num_horas && apunte.detalles.num_horas > 0"><b>Núm. horas:</b> {{ apunte.detalles.num_horas }}</li>
      </template>
      <template v-if="false && apunte.tipo == 'ingreso'">
      <li><b>Fecha del ingreso:</b> {{ apunte.detalles.fecha | fecha }}</li>
      </template>
      <template v-if="false && apunte.tipo == 'pago_metalico'">
      <li><b>Fecha del pago:</b> {{ apunte.detalles.fecha | fecha }}</li>
      </template>
      <template v-if="apunte.tipo == 'recibo_domiciliado'">
      <li><b>Referencia:</b> <i>(no disponible)</i></li>
      <template v-if="true || admin">
      <div class="col-6">
        <div class="card mt-3">
          <h5 class="card-header bg-secondary text-white">Recibo devuelto</h5>
          <div class="card-body">
            <form class="form-horizontal" id="recibo-devuelto" action="" @submit.stop.prevent="enviarDevolucionRecibo">
              <fieldset>
                <div class="form-group row">
                  <label class="col-5 col-form-label" for="fecha">Fecha de devolución</label>
                  <div class="col-7">
                    <input id="fecha" name="fecha" type="text" class="form-control" v-mask="'##/##/####'" placeholder="dd/mm/aaaa" v-model="fecha_devolucion">
                  </div>
                </div>
                <p class="text-right mb-0"><button type="submit" class="btn btn-outline-secondary mt-1">Recibo devuelto</button></p>
              </fieldset>
            </form>
          </div>
        </div>
      </div>
      </template>
      </template>
    </ul>

  </div>
</template>

<script>

import { api } from '../api/api.js';

export default {
	name: 'AdminApunteDetaille',
	props: [ 'id_familia', 'id_apunte' ],
	data () {
		return {
			apunte: null,
			fecha_devolucion: null,
		}
	},
	created () {
		this.obtenerApunte();
	},
	methods: {
		obtenerApunte() {
			api(`/familias/${this.id_familia}/apunte/${this.id_apunte}`, 'GET')
			.then((data) => {
				this.apunte = data.resultado;
			})
			.catch((error) => {
				this.mensaje_error = error;
			});
		},
		enviarDevolucionRecibo() {
			const datos = {
				'fecha': this.fecha_devolucion,
			}
			api(`/familias/${this.id_familia}/apunte/${this.apunte.id_apunte}/devolucion`, 'POST', datos)
                .then((data) => {
					if (data.resultado) {
						this.$router.push(`/admin/familia/${this.id_familia}/balance`);
					} else {
						this.mensaje_error = 'Error desconocido';
					}
                })
                .catch((error) => {
                    this.mensaje_error = error;
                });
		}
	},
	filters: {
		// FIXME: Repetido de SociosBalance
		fechaTimestamp(timestamp) {
			const d = new Date(timestamp * 1000);
			return `${d.getDate()}/${d.getMonth()+1}/${d.getFullYear()}`;
		}
	}
}
</script>
